import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';
import AppStoreLinks from 'components/app-store-links/AppStoreLinks';

import { __t, applyTranslations } from 'utils/language';
import { triggerConsentPreferencesDialog } from 'utils/consents';

import './footer.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./footer.i18n.json'));

export const EXTERNAL_WEBSITE_LINK = 'https://www.collabary.com';
export const EXTERNAL_HELP_LINK = 'http://help.collabary.com';

const Footer = () => (
  <footer className="footer">
    <div className="layout-container">
      <div className="footer__menus">
        <ul className="footer__nav">
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/brands-agencies/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_brands_and_agencies')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/creators/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_creators')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/pricing/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_packages')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/blog/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_blog')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_HELP_LINK}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_faq')}
            </a>
          </li>
        </ul>
        <ul className="footer__nav">
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/about-us/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_about')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/guidelines/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_guidelines')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/terms-and-conditions/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_terms')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/privacy-notice/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_privacy')}
            </a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/news-press/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_imprint')}
            </a>
          </li>
        </ul>
        <ul className="footer__nav">
          <li>
            <a href="/login">{__t('footer.footer_link_login')}</a>
          </li>
          <li>
            <a href="/signup">{__t('footer.footer_link_signup')}</a>
          </li>
          <li>
            <a
              href={`${EXTERNAL_WEBSITE_LINK}/contact/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {__t('footer.footer_link_contact')}
            </a>
          </li>
          <li>
            <a
              href="#uc-central-modal-show"
              onClick={triggerConsentPreferencesDialog}
            >
              {__t('footer.footer_link_tracking')}
            </a>
          </li>
        </ul>
      </div>
      <div className="footer__app-store-links">
        <AppStoreLinks />
      </div>
      <div className="footer__back-to-top">
        <a href="#" className="footer__back-to-top-link">
          {__t('footer.footer_link_back_to_top')}
          <span className="footer__back-to-top-arrow">
            <SVGDynamicIcon
              name="arrow-up-custom-bg"
              width={11}
              height={11}
              customColor="white"
            />
          </span>
        </a>
      </div>

      <div className="footer__logos">
        <a
          href="/"
          className="footer__logo"
        >
          <img
            data-src="/static/images/logo-footer-white.svg"
            className="lazyload"
            alt={__t('collabary_common.site_name')}
          />
        </a>
        <a
          href="https://www.zalando.de"
          target="_blank"
          rel="noopener noreferrer"
          className="footer__zalando-logo"
        >
          <img
            data-src="/static/images/footer-zalando.png"
            className="lazyload"
            alt={__t('footer.footer_zalando_alt')}
          />
        </a>
      </div>

    </div>
  </footer>
);

export default Footer;
